import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import InputMask from "react-input-mask"; // 추가된 임포트

const MaskEditCellEditor = forwardRef((props: any, ref) => {
  const [value, setValue] = useState(props.value || ""); // 초기값 설정
  const [mask, setMask] = useState("");

  useEffect(() => {
    // 마스크 유형에 따라 마스크 패턴 설정
    switch (props.maskType) {
      case "password":
        setMask(""); // 패스워드는 마스크 없이 처리
        break;
      case "business":
        setMask("999-99-99999"); // 사업자 번호
        break;
      case "phone":
        setMask("999-9999-9999"); // 전화번호
        break;
      case "postal":
        setMask("99999-999"); // 우편번호
        break;
      default:
        setMask(""); // 기본값: 마스크 없음
    }
  }, [props.maskType]);

  // ag-Grid와 상호작용
  useImperativeHandle(ref, () => ({
    getValue: () => value.trim(), // 값 반환
    afterGuiAttached: () => {
      // 에디터 초기화 시 실행
      setValue(props.value || "");
    },
  }));

  return (
    <InputMask
      mask={mask}
      value={value}
      onChange={(e: { target: { value: any } }) => setValue(e.target.value)} // 값 변경
      placeholder={props.maskType ? props.maskType.toUpperCase() : ""}
      type={props.maskType === "password" ? "password" : "text"}
      className="ag-input-field-input ag-text-field-input"
    />
  );
});

export default MaskEditCellEditor;
